import Vue from 'vue'
import Vuex from 'vuex'
/* MODULES */
import auth from '@/store/modules/auth'
import reserve from '@/store/modules/reserve'
import navigation from '@/store/modules/navigation'
import orders from '@/store/modules/orders'
import companies from '@/store/modules/companies'
import personal from '@/store/modules/personal'
import creditcard from '@/store/modules/creditcard'
import policy from '@/store/modules/policy'
import providers from '@/store/modules/providers'
import hotels from '@/store/modules/hotels'
import flights from '@/store/modules/flights'
import cars from '@/store/modules/cars'
import travelers from '@/store/modules/travelers'
import user from '@/store/modules/user'
import notification from '@/store/modules/notification'

Vue.use(Vuex);

const SET_CLEARSALE_TOKEN = 'SET_CLEARSALE_TOKEN';
const SET_MAINTENANCE = 'SET_MAINTENANCE'

const store = new Vuex.Store({
  state: {
    maintenance: false,
    clearSaleToken: '',
    countries: []
  },
  mutations: {
    [SET_CLEARSALE_TOKEN](state, token) {
      state.clearSaleToken = token
    },
    [SET_MAINTENANCE](state, payload) {
      state.maintenance = payload
    }
  },
  actions: {
    set_clearsale_token({commit}, token){
      commit(SET_CLEARSALE_TOKEN, token);
    }
  },
  getters: {
    get_clearsale_token: state => {
      if (!state.clearSaleToken) {
        return document.querySelector('#ClearSaleSessionID').value
      }
      return state.clearSaleToken;
    }
  }
});

store.registerModule('auth', auth);
store.registerModule('reserve', reserve);
store.registerModule('navigation', navigation);
store.registerModule('orders', orders);
store.registerModule('companies', companies);
store.registerModule('personal', personal);
store.registerModule('creditcard', creditcard);
store.registerModule('policy', policy);
store.registerModule('providers', providers);
store.registerModule('hotels', hotels);
store.registerModule('flights', flights);
store.registerModule('cars', cars);
store.registerModule('travelers', travelers);
store.registerModule('user', user);
store.registerModule('notification', notification);

export default store;
